module.exports = __webpack_public_path__ + "img/e1e4e229c4d20ae68186cc7b6e9b114c.svg";